import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { BookCrdtnoteRcptComponent } from '../pages/book-crdtnote-rcpt/book-crdtnote-rcpt.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-book-commission-note-register',
  templateUrl: './book-commission-note-register.component.html',
  styleUrl: './book-commission-note-register.component.scss'
})
export class BookCommissionNoteRegisterComponent {

   crdtNoteData;
    BookBillingData;
    selectedBooks;
    crdtnotetotal;
    toWords;
    crdtnotetotalwords;
    totalamount = 0;
    crdtnoteamttotal = 0;
    remainingTotal = 0;
    address;
    bookcreditdata;
    crdreturncopies = 0
    payloadArray;
    receiptdata;
    commission_no;
    data:any;
  
    crdtnotedata:any;
    creditNoteList :any;
  
    constructor(
      public service: DigisubservicesService,
      private dialogRef: MatDialogRef<BookCrdtnoteRcptComponent>,
      @Inject(MAT_DIALOG_DATA) public dataa: any
    ) {
      console.log('bookCommnote data', this.dataa);
    }
  
    ngOnInit(): void {
      this.crdtNoteData = this.dataa['receiptdata'];
      this.commission_no = this.crdtNoteData.map(item => item.commission_no);
    
      console.log(this.commission_no, "comm number");
      
      this.service.getBookCommwise(this.commission_no).subscribe((res) => {
        
        this.creditNoteList = (res as any[]).map(note => {
          const total = note.commission_no_data.reduce((sum, item) => {
            return sum + parseFloat(item.select_entry_amt);
          }, 0);
          
          this.toWords = new ToWords();
  
  
          const totalInWords = this.toWords.convert(total, {
            currency: true,
          });
  
        
          return {
            ...note,
            totalAmount: total,
            crdtnotetotalwords: totalInWords
          };
        });
        
            console.log(this.data)
  
      });
  
  
    }
  
    print(): void {
      window.print();
    }
  
    
    ConvertToInt(val) {
      return parseInt(val);
    }
}
